import { render, staticRenderFns } from "./_BirthdayPicker.vue?vue&type=template&id=ac6ae9dc&"
import script from "./_BirthdayPicker.vue?vue&type=script&lang=js&"
export * from "./_BirthdayPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports